


export enum CountryEnum {
	cz = 'CZ',
	sk = 'SK',
}